import { Component, Vue } from 'vue-property-decorator';
import Configuration from '@/types/Configuration';

@Component
export default class ToasterMixin extends Vue {
     public showToaster(message: string, title: string, variant: string) {
        this.$root.$bvToast.toast(message, {
            title: title,
            autoHideDelay: Configuration.ToasterAutoHideDelay,
            appendToast: true,
            variant: variant,
            toaster: Configuration.ToasterPosition
        });
    }
}
